const doc = [({"en":({"js":({"admin":({"required_metadata":({"card":({"personal":"Personal", "contact":"Contact", "required_metadata":"Required metadata"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;